module.exports = __webpack_public_path__ + "static/media/category.a4d5ad39.svg";